export enum BusinessIntelligenceGroupingEnum {
  DAY,
  WEEK,
  MONTH,
  YEAR,
}
